<template>
  <div class="management-wrap">
    <div class="top" v-loading="loading">
      <p><i :style="{ background: 'url(' + require('@/assets/image/default/management/outline.png') +')' }"></i><span>今日情况概要</span></p>
      <div>
        <el-card class="box-card" v-for="item in list" :key="item.id" :style="{ backgroundColor: item.backgroundColor }">
          <div slot="header" class="clearfix">
            <span>{{item.text}}</span>
            <img :src="item.img">
          </div>
          <div class="text item">
            {{item.num}}
            <i>元</i>
          </div>
        </el-card>
      </div>
    </div>
    <div class="bottom" v-loading="tableLoading">
      <p><i :style="{ background: 'url(' + require('@/assets/image/default/management/ranking.png') +')' }"></i><span>销售排行</span></p>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="客户销售排行" name="first">
          <el-table v-if="activeName === 'first'" :data="tableData" stripe height="100%" max-height="100%" style="width: 99.9%;">
            <el-table-column type="index" label="排名"></el-table-column>
            <el-table-column prop="latitudeName" label="客户名称" align="center"></el-table-column>
            <el-table-column prop="collectDataTotal" label="本月销售额" align="center"></el-table-column>
            <el-table-column prop="remark1" label="本月退货额" align="center"></el-table-column>
            <el-table-column prop="remark2" label="销-退" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="业务员销售排行" name="second">
          <el-table v-if="activeName === 'second'" :data="tableData" stripe height="100%" max-height="100%" style="width: 99.9%;">
            <el-table-column type="index" label="排名"></el-table-column>
            <el-table-column prop="latitudeName" label="业务员名称" align="center"></el-table-column>
            <el-table-column prop="collectDataTotal" label="本月销售额" align="center"></el-table-column>
            <el-table-column prop="remark1" label="本月退货额" align="center"></el-table-column>
            <el-table-column prop="remark2" label="销-退" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="商品销售排行" name="third">
          <el-table v-if="activeName === 'third'" :data="tableData" stripe height="100%" max-height="100%" style="width: 99.9%;">
            <el-table-column type="index" label="排名"></el-table-column>
            <el-table-column prop="latitudeName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="collectDataTotal" label="本月销售额" align="center"></el-table-column>
            <el-table-column prop="remark1" label="本月退货额" align="center"></el-table-column>
            <el-table-column prop="remark2" label="销-退" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      list: [
        {
          id: 1,
          backgroundColor: '#1c4934',
          img: require('@/assets/image/default/management/volume.png'),
          text: '总销售额',
          num: 0
        },
        {
          id: 2,
          backgroundColor: '#e0a85e',
          img: require('@/assets/image/default/management/stock.png'),
          text: '总库存',
          num: 0
        },
        {
          id: 3,
          backgroundColor: '#ed662f',
          img: require('@/assets/image/default/management/cost.png'),
          text: '总费用',
          num: 0
        }
      ],
      tableData: [],
      tableLoading: false,
      loading: false
    }
  },
  created () {
    this.getManageData()
    this.getSortData()
  },
  methods: {
    handleClick () {
      this.getSortData()
    },
    async getManageData () {
      this.loading = true
      const { data: res } = await this.$http.post('/Account/_public/buildManageDataPreviewMinVUE.html')
      this.loading = false
      if (res.code != 'success') return this.$message.error(res.message)
      const { todayTotalSales = 0, itemInvs = 0, todayTotalFees = 0 } = JSON.parse(res.result)
      this.$set(this.list[0], 'num', todayTotalSales)
      this.$set(this.list[1], 'num', itemInvs)
      this.$set(this.list[2], 'num', todayTotalFees)
    },
    async getSortData () {
      let url = '/Account/_public/buildStoreSortDataVUE.html'
      if (this.activeName == 'first') {
        url = '/Account/_public/buildStoreSortDataVUE.html'
      } else if (this.activeName == 'second') {
        url = '/Account/_public/buildSaleManSortDataVUE.html'
      } else if (this.activeName == 'third') {
        url = '/Account/_public/buildGoodSortDataVUE.html'
      }
      this.tableData = []
      this.tableLoading = true
      const { data: res } = await this.$http.post(url)
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let result = JSON.parse(res.result)
      this.tableData = JSON.parse(result.data)
    }
  }
}
</script>

<style lang="less" scoped>
  .management-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    p {
      display: flex;
      align-items: center;
      background-color: #f6f4ef;
      border-radius: 4px;
      margin: 20px 0;
      height: 30px;
      line-height: 30px;
      i {
        display: inline-block;
        width: 20px;
        height: 16px;
        margin-left: 12px;
      }
      span {
        font-size: 16px;
        font-size: 0.8vw;
        color: #4a4a4d;
        margin-left: 10px;
      }
    }
    .top {
      flex-shrink: 0;
      >div {
        display: flex;
        justify-content: space-between;
        ::v-deep .box-card {
          width: 30%;
          height: 130px;
          position: relative;
          color: #fff;
          font-size: 20px;
          box-shadow: 0px 8px 18px 0px rgba(18, 58, 50, 0.12);
          border-radius: 16px;
          span {
            font-size: 1.2vw;
          }
          .el-card__header {
            border: none;
          }
          .el-card__body {
            width: 100%;
            padding: 0;
            .item {
              padding: 0 20px 20px;
              font-size: 1.6vw;
            }
          }
          img {
            width: 20%;
            position: absolute;
            top: 50%;
            transform: translate(20%, -50%);
            right: 0;
            opacity: 0.2;
          }
        }
      }
    }
    .bottom {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 300px;
      ::v-deep .el-tabs__item.is-active {
        color: #123a32;
      }
      ::v-deep .el-tabs__item:hover {
        color: #1c4934;
      }
      ::v-deep .el-tabs__active-bar {
        background-color: #123a32;
      }
      // height: calc(100% - 202px);
      // ::v-deep .el-tabs {
      //   height: calc(100% - 50px);
      // }
    }
  }
</style>
